export const TEAM_LINK_TYPES = ['user', 'affiliate', 'affiliateGroupsAdmin', 'customer']

export const PORTAL_ROLES = ['contact', 'co-applicant']

export const isPortalRole = (role) => PORTAL_ROLES.includes(role)

export const CLIENT_PORTAL_LABEL = 'Client Portal'

export const TEAM_PORTAL_LABEL = 'Team Portal'

const TEAM_PORTAL_PATH = '/team-portal'

const INTERNAL_FLOW = /\/internal(\/|$)/

const CREATE_PASSWORD = /^\/create-password\/([^/]+)/

const FIRM_BRANDED_PUBLIC_PATHS = ['/enrollment', '/success/signing']

export const isInternalFlowPath = (pathname) => INTERNAL_FLOW.test(pathname || '')

export const isTeamPath = (pathname) => {
  const path = pathname || ''
  if (path === TEAM_PORTAL_PATH) return true
  if (isInternalFlowPath(path)) return true
  const createPassword = path.match(CREATE_PASSWORD)
  return Boolean(createPassword && TEAM_LINK_TYPES.includes(createPassword[1]))
}

export const isFirmBrandedPublicPath = (pathname) => {
  const path = pathname || ''
  return FIRM_BRANDED_PUBLIC_PATHS.some((route) => path === route || path.startsWith(`${route}/`))
}
